export default [
    {id:10,label:"Senyalització Bombers (FOER)",layers:["foer-point","foer-point2",],visibility:false}, 
    {id:11,label:"Senyalització 112",layers:["112-point","112-point2",],visibility:false}, 
    {id:12,label:"Desfibril·lador (DEA)",layers:["dea"],visibility:false},
]
